// extracted by mini-css-extract-plugin
export default {"bannerComponent":"dl-z","red":"el-z","calloutlink":"fl-z","headerTopBanner":"gl-z","bgcolorRed":"hl-z","headerTopCallout":"il-z","searchBanner":"jl-z","hideMobile":"kl-z"};